var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",style:(_vm.background),attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('downloadPdf')}}},[_vm._v(" SAVE AS PDF ")])
}
var staticRenderFns = []

export { render, staticRenderFns }